import { memo } from 'react';
import { RankedTester, rankWith, schemaMatches, WithClassname } from '@jsonforms/core';
import { TranslateProps, withJsonFormsOneOfEnumProps, withTranslateProps } from '@jsonforms/react';
import MuiAutocomplete from './component';
import get from 'lodash/get';

export const MaterialEnumCell = (props: any & WithClassname & TranslateProps) => <MuiAutocomplete {...props} />;

/**
 * Default tester for enum controls.
 * @type {RankedTester}
 */
// export const secretAutoCompleteTester: RankedTester = rankWith(10, or(scopeEndsWith('secret_1'),scopeEndsWith('secret_2')));
export const secretAutoCompleteTester: RankedTester = rankWith(
  1000,
  schemaMatches((schema) => schema.hasOwnProperty('secret') && get(schema, 'secret', false))
);

export default withJsonFormsOneOfEnumProps(withTranslateProps(memo(MaterialEnumCell)), false);
